export default __webpack_public_path__ + "static/media/Group1497-Rotate@2x.b6ecdbf0.png";